import React from "react";
import { GhostInfoIcon, IconArrowDown } from "../../../../Components/Icons";
import { CollapseHeaderContent } from "./BookingFinished.styled";
import { Tooltip } from "../../../../Components/Overlays";

const defaultState = {
  adPreview: false,
  campaign: false,
  learning: false
};

export const CollapseHeader = ({ id, active, setShow, text, tooltip }) => {
  return (
    <CollapseHeaderContent
      onClick={() =>
        setShow({
          ...defaultState,
          [id]: true
        })
      }
      active={active}
    >
      <IconArrowDown size={30} />
      <div>
        {text}
        {tooltip && (
          <Tooltip
            label={tooltip}
            bgColor="#fff"
            color="#000"
            styles={{
              filter: "drop-shadow(0px 9px 18px rgba(0, 0, 0, 0.15))",
              opacity: "1",
              fontFamily: "Rubik",
              fontSize: "12px",
              fontWeight: 400,
              lineHight: "21px"
            }}
          >
            <GhostInfoIcon size={18} />
          </Tooltip>
        )}
      </div>
    </CollapseHeaderContent>
  );
};
